export const environment = {
  production: false,
  apiBaseUrl: 'https://calendarshareapidev.cordelllaw.com',
  msalConfig: {
    auth: {
      clientId: '7ec3bc26-e843-4f65-bcf6-9b237e971362', // Azure AD Application (client) ID
      authority: 'https://login.microsoftonline.com/a3a79d12-cac2-4d4d-82a4-22eeb4946eda', // Azure AD Tenant ID or 'common'
      redirectUri: 'https://calendarshareadmindev.cordelllaw.com', // Must match redirect URI in Azure AD app registration
      postLogoutRedirectUri: 'https://calendarshareadmindev.cordelllaw.com'
    }
  },
  showClaimsDebug: true,
  apiConfig: {
    scopes: [
      'api://lexicon-calendarshare-dev/calendarshare.read',
      'api://lexicon-calendarshare-dev/calendarshare.write'
    ], // API scopes for access token
    uri: 'https://calendarshareapidev.cordelllaw.com'
  }
};
